export var SearchIconEnum;
(function (SearchIconEnum) {
    SearchIconEnum["chat"] = "chat";
    SearchIconEnum["tasks"] = "tasks";
    SearchIconEnum["calendar"] = "calendar";
})(SearchIconEnum || (SearchIconEnum = {}));
